/* ============================================================================
 * th-mailchimp.js — subscribe to Mailchimp in place, no new tab, no reload.
 * ----------------------------------------------------------------------------
 * Mailchimp's normal /subscribe/post endpoint cannot be called with fetch or
 * XHR (no CORS headers), which is why the stock embed uses target="_blank" and
 * navigates away. Their /subscribe/post-json endpoint answers JSONP, so we
 * inject a script tag and read the result:  {result:"success"|"error", msg:"…"}
 *
 * Opt in per form with  data-mc-jsonp  on a <form> whose action is the regular
 * list-manage /subscribe/post URL — the endpoint is rewritten here, so the
 * markup keeps working natively if this file fails to load.
 *
 * Only the fields present in the form are sent (EMAIL + the hidden tags value
 * + Mailchimp's honeypot). Nothing else is collected.
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__thMcBound) return;          /* two sections load this on one page */
  window.__thMcBound = true;
  if (!document.querySelector || !window.encodeURIComponent) return;

  var seq = 0;

  /* ---- JSONP ------------------------------------------------------------- */
  function jsonp(url, done) {
    var cb = '__thMc' + (++seq) + '_' + Math.floor(Math.random() * 1e9);
    var script = document.createElement('script');
    var timer;
    function cleanup() {
      clearTimeout(timer);
      window[cb] = undefined;
      try { delete window[cb]; } catch (e) {}
      if (script.parentNode) script.parentNode.removeChild(script);
    }
    window[cb] = function (data) { cleanup(); done(null, data); };
    script.onerror = function () { cleanup(); done(new Error('network')); };
    timer = setTimeout(function () { cleanup(); done(new Error('timeout')); }, 12000);
    script.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'c=' + cb;
    document.head.appendChild(script);
  }

  /* ---- helpers ----------------------------------------------------------- */
  function endpoint(form) {
    var a = form.getAttribute('action') || '';
    if (a.indexOf('/subscribe/post-json') > -1) return a;
    return a.replace('/subscribe/post', '/subscribe/post-json');
  }

  function payload(form) {
    var out = [];
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled) return;
      if (el.type === 'submit' || el.type === 'button') return;
      out.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value == null ? '' : el.value));
    });
    return out.join('&');
  }

  function msgBox(form) {
    var box = form.querySelector('[data-mc-msg]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-mc-msg', '');
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      form.appendChild(box);
    }
    return box;
  }

  /* Mailchimp prefixes errors with a field index ("0 - …") and can return HTML;
     render as text so nothing from the response is injected as markup. */
  function clean(msg) {
    var text = String(msg || '').replace(/^\s*\d+\s*-\s*/, '');
    var tmp = document.createElement('div');
    tmp.innerHTML = text;
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  function show(form, kind, text) {
    var box = msgBox(form);
    box.textContent = text;
    box.setAttribute('data-mc-state', kind);
    form.classList.remove('is-sending');
    form.classList.toggle('is-done', kind === 'success');
  }

  function busy(form, on) {
    form.classList.toggle('is-sending', on);
    Array.prototype.forEach.call(form.querySelectorAll('button, input[type="submit"]'), function (b) {
      b.disabled = on;
    });
  }

  /* ---- submit ------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !form.hasAttribute('data-mc-jsonp')) return;

    var email = form.querySelector('input[name="EMAIL"]');
    /* the stock embed carries novalidate, so validate here rather than rely on the browser */
    if (email && typeof email.checkValidity === 'function' && !email.checkValidity()) {
      e.preventDefault();
      show(form, 'error', email.value.trim() ? 'That email address looks incomplete.' : 'Enter your email address first.');
      email.focus();
      return;
    }
    e.preventDefault();
    if (form.dataset.mcBusy) return;
    form.dataset.mcBusy = '1';
    busy(form, true);
    msgBox(form).removeAttribute('data-mc-state');

    jsonp(endpoint(form) + '&' + payload(form), function (err, data) {
      delete form.dataset.mcBusy;
      busy(form, false);
      if (err || !data) {
        /* Never lose a signup: hand it to Mailchimp the old way. */
        show(form, 'error', 'Connection problem — opening the signup page instead.');
        form.removeAttribute('data-mc-jsonp');
        form.submit();
        return;
      }
      if (data.result === 'success') {
        show(form, 'success', clean(data.msg) || "You're on the list. Watch your inbox for the launch email.");
        if (email) email.value = '';
      } else {
        show(form, 'error', clean(data.msg) || 'That signup did not go through. Try again in a moment.');
        if (email) email.focus();
      }
    });
  });
})();
